// extracted by mini-css-extract-plugin
export default {"patchQuestionIcon":"SignatureStatusRenderer_patchQuestionIcon__5C3n3","approvalStatusWrapper":"SignatureStatusRenderer_approvalStatusWrapper__KUpMQ"};